module.exports = __webpack_public_path__ + "img/rep-clar.a657c999.svg";